<template>
    <Card :class="(activeIndex === 1 || activeIndex === 2) && !isReadonly ? 'appendix' : 'report'"
        v-show="!pointSelectMode">
        <template #title>
            Report
            <div style="display: flex; justify-content: center;">
                <p class="p-component" style="margin-top: 10px; margin-bottom: -5px; max-width: 80%;">
                    Generate a construction noise management report by filling in the fields. Click next to preview the
                    appendix. Click next to fill in contact information and upload supporting materials, then submit.
                </p>
                <Button icon="pi pi-times" class="p-button-rounded p-button-secondary p-button-text"
                    style="position:fixed;right:10px" @click="close()" aria-label="Close" />
            </div>
        </template>

        <template #content>
            <div class="contentPanel" v-show="loading" style="position:relative">
                <div style="position:absolute;top:50%;left:50%;transform: translate(-50%,-50%);text-align:center">
                    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                    <h3>Generating Report</h3>
                </div>
            </div>
            <div v-if="!loading">
                <Report v-if="!isReadonly && !loading && activeIndex === 0" :project="project" :printMode="printMode"
                    :userInput="userInput" />
                <ScrollPanel class="contentPanel" v-show="activeIndex === 0" v-if="isReadonly">
                    <label class="field col-12">Submitted reports:</label>
                    <UploadFile class="field col-12"
                        :files="project.reports.sort((a, b) => (a.filename > b.filename) ? 1 : -1)"
                        :endpoint="`${fileEndpoint}${project.guid}`" preview :disabled="project.readonly">
                    </UploadFile>
                </ScrollPanel>
                <Appendix v-if="!isReadonly && !loading && activeIndex === 1" :project="project"
                    :neighborProjects="neighborProjects" :printMode="printMode" />
                <div id="appendixContainer"></div>
                <ScrollPanel class="contentPanel" v-show="activeIndex === 1" v-if="isReadonly">
                    <label v-if="isReadonly" class="field col-12">Submitted appendix:</label>
                    <UploadFile v-if="isReadonly" class="field col-12"
                        :files="project.appendix.sort((a, b) => (a.filename > b.filename) ? 1 : -1)"
                        :endpoint="`${fileEndpoint}${project.guid}`" preview :disabled="project.readonly">
                    </UploadFile>
                </ScrollPanel>
                <ScrollPanel class="contentPanel" v-show="activeIndex === 2">
                    <div class="formgrid grid">
                        <h4 class="col-12">Contact Information</h4>
                        <div class="col-6" style="display: flex;">
                            <label for="roleInProject" class="field fieldLabel" style="padding-right: 10px;">*Role in
                                Project:</label>
                            <InputText class="field " v-model="roleInProject" aria-describedby="project-role"
                                aria-label="roleInProject" style="flex:1" />
                        </div>
                        <div class="col-6" style="display: flex;">
                            <label for="email" class="field fieldLabel" style="padding-right: 10px;">*Email:</label>
                            <InputText class="field" v-model="email" aria-describedby="email" aria-label="email"
                                style="flex:1" />
                        </div>
                        <label class="field col-12 fieldLabel p-error" v-if="checkSupportMaterial && !isReadonly">Please
                            upload support materials for user defined sound power.</label>
                        <SupportMaterialTable class="field col-12" :equipments="userDefinedEquipments"
                            :project="project" mode="all">
                        </SupportMaterialTable>
                        <label class="field col-12">Other Attachments:</label>
                        <label v-if="project.attachments.length == 0 && isReadonly" class="field col-12">No other
                            attachment
                            for
                            this project.</label>
                        <UploadFile class="field col-12" format="*" :id="`selectAttachments`" multiple="multiple"
                            @upload="uploadAttachments" :files="project.attachments" label="Upload Attachments"
                            :endpoint="`${fileEndpoint}${project.guid}`" preview :disabled="isReadonly">
                        </UploadFile>
                    </div>
                </ScrollPanel>
            </div>
        </template>
        <template #footer>
            <div class="formgrid grid" v-show="activeIndex === 0">
                <div class="field col-12 md:col-3">
                    <!-- <Button style="float: left;width:100px" icon="pi pi-eye" label="Select NSR"
                        @click="selectNSRPointsToReport"></Button> -->
                    <!-- <Button style="float: left;" icon="pi pi-eye" label="Test Select NSR"
                        @click="selectNSRPointsToReport"></Button> -->
                </div>
                <div class="field col-12 md:col-5">
                </div>
                <div class="field col-12 md:col-2">
                    <Button v-show="!printMode" style="float: right;width:100px" icon="pi pi-eye" label="Preview"
                        @click="togglePrintMode" v-if="!isReadonly"></Button>
                    <Button v-show="printMode" style="float: right;width:100px" icon="pi pi-pencil" label="Edit"
                        @click="togglePrintMode(); submitting = false; submitLabel = 'Submit'"
                        :disabled="submitLabel === 'Submitting' || submitLabel === 'Submitted'"
                        v-if="!isReadonly"></Button>
                </div>
                <div class="field col-12 md:col-2">
                    <Button v-if="!isReadonly" label="Next" :icon="saving" style="float: left;width:100px"
                        @click="saveReport();" :disabled="saving == 'pi pi-spin pi-spinner'" />
                    <Button v-else label="Next" :icon="saving" style="float: left;width:100px" @click="nextPage" />
                </div>
            </div>
            <div class="formgrid grid" v-show="activeIndex === 1">
                <div class="field col-12 md:col-10">
                    <Button class="p-button-secondary" label="Back" icon="pi pi-angle-left"
                        style="float: left;width:100px" @click="prevPage" />
                </div>
                <div class="field col-12 md:col-2">
                    <Button v-if="!isReadonly" label="Next" :icon="saving" style="float: left;width:100px"
                        @click=" saving = 'pi pi-spin pi-spinner'; saveAppendix();"
                        :disabled="saving == 'pi pi-spin pi-spinner'" />
                    <Button v-else label="Next" :icon="saving" style="float: left;width:100px" @click="nextPage" />
                </div>
            </div>
            <div class="formgrid grid" v-show="activeIndex === 2">
                <div class="field col-12 md:col-10">
                    <Button class="p-button-secondary" label="Back" icon="pi pi-angle-left"
                        style="float: left;width:100px" @click="prevPage" />
                </div>
                <div class="field col-12 md:col-2">
                    <Button style="float: left;width:100px" :icon="submitting ? 'pi pi-spin pi-spinner' : 'pi pi-send'"
                        :label="submitLabel" @click.prevent="submit"
                        :disabled="checkSupportMaterial || submitLabel === 'Submitting' || submitLabel === 'Submitted' || email === '' || roleInProject === ''"
                        v-if="!isReadonly || submitLabel === 'Submitted'" type="submit"></Button>
                </div>
            </div>
        </template>
    </Card>
    <div class="minimizeRight" v-show="pointSelectMode">
        <Card style="height:69vh">
            <template #title>
                Select the NSR points to include in Report <h6>Hold CTRL + Drag mouse, to draw the selection rectangle
                </h6>
                <!-- <Button icon="pi pi-window-maximize" class="p-button-rounded p-button-secondary p-button-text"
                    style="position:fixed;right:10px" @click="doneSelect" /> -->
            </template>
            <template #content>

                <div class="formgrid grid">
                    <ScrollPanel style="width:100%; height:40vh; margin-bottom: 1vh;">
                        <table id="selectedNSRTable" class="field col-12 md:col-12 fieldLabel">
                            <tr>
                                <td>id:</td>
                                <td><label id="myLabel">col2</label></td>
                                <td>name:</td>
                                <td>
                                    <InputText id="myText" type="text" />
                                </td>
                            </tr>
                            <tr>
                                <td>id:</td>
                                <td>col2</td>
                                <td>name:</td>
                                <td>col2</td>
                            </tr>
                            <tr>
                                <td>id:</td>
                                <td>col2</td>
                                <td>name:</td>
                                <td>col2</td>
                            </tr>
                            <tr>
                                <td>id:</td>
                                <td>col2</td>
                                <td>name:</td>
                                <td>col2</td>
                            </tr>
                        </table>
                    </ScrollPanel>
                    <!-- <div class="field col-12 md:col-4 fieldLabel">
                                    <div class="verticalBoxContainer"> 
                    <label for="drawbutton" class="field col-12 md:col-2 fieldLabel">Site:</label>-->
                    <Button id="deselectbutton" label="Deselect" icon="pi pi-circle" @click="changeSelectionMode"
                        class="field col-12 md:col-4 fieldLabel" v-if="selectionMode === 1" />
                    <Button id="selectbutton" label="Select" icon="pi pi-circle-fill" @click="changeSelectionMode"
                        class="field col-12 md:col-4 fieldLabel" v-if="selectionMode === 0" />
                    <Button id="clearbutton" label="Clear Selection" icon="pi pi-trash" @click="clearSelection"
                        class="field col-12 md:col-4 fieldLabel" />
                    <Button id="donebutton" label="Done" icon="pi pi-check" @click="doneSelect"
                        class="field col-12 md:col-4 fieldLabel" />
                    <label class="field col-12 md:col-12 fieldLabel" style="line-height:2vh;">The bigger size points on
                        the map shows maximum 20 calculated sound power level on NSR.</label>
                    <!--<div class="field col-12 md:col-4 fieldLabel"></div> 
                    <label for="drawbutton2" class="field col-12 md:col-2 fieldLabel">Zones:</label>
                    <Button id="drawbutton2" label="Draw" icon="pi pi-pencil" @click="switchZoneCutterDraw"
                        class="field col-12 md:col-2 fieldLabel" />
                    <Button id="drawbutton" label="Clear" icon="pi pi-trash" @click="clearZoneDraw"
                        class="field col-12 md:col-2 fieldLabel" />-->
                </div>
            </template>
        </Card>
    </div>
    <div class="center" v-if="submitting">
        <Card style="height:10vh">
            <template #title>
                Report Submitting
            </template>
            <template #content>
                <ProgressBar class="col-12 md:col-2"
                    :value="(progress * 100 / totalProgress) > 100 ? 100 : Math.round(progress * 100 / totalProgress)"
                    style="padding:0px;width: 100%;" />
            </template>
        </Card>
    </div>
    <div class="center" v-if="showSubmit">
        <Card style="height:10vh">
            <template #title>
                {{ submitPopupLabel }}
            </template>
            <template #content>
                <Button style="width:100px" label="Close" @click="showSubmit = false"></Button>
            </template>
        </Card>
    </div>
</template>

<script>
import Report from '@/components/report module/Report.vue';
import Appendix from '@/components/report module/Appendix.vue';
import DateHelper from '@/helper/DateHelper';
import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';
import UploadFile from '@/components/UploadFile.vue';
import SupportMaterialTable from '@/components/report module/SupportMaterialTable.vue';
import MapOL from "@/libs/myOpenLayers.js"

export default {
    name: 'ReportView',
    components: {
        Report,
        Appendix,
        UploadFile,
        SupportMaterialTable
    },
    data() {
        return {
            project: this.getCurrentProject(),
            neighborProjects: [],

            activeIndex: 0,
            printMode: false,
            saving: "pi pi-angle-right",
            submitting: false,
            submitLabel: "Submit",
            submitPopupLabel: "Report Submitted",

            userDefinedEquipments: [],
            supportMaterials: [],
            attachments: [],

            blobs: [],
            loading: true,
            showSubmit: false,

            pointSelectMode: false,
            selectionMode: 1,

            map: null,

            progress: 0,
            totalProgress: 0,

            roleInProject: "",
            email: "",

            userInput: {
                general: {
                    versionNo: "",
                    date: new Date().toISOString().split('T')[0],
                    lastUpdate: ""
                },
                cpoa: {
                    cnp: {
                        status: "",
                        details: ""
                    },
                    ep: {
                        status: "",
                        details: ""
                    },
                    exp: {
                        status: "",
                        details: ""
                    },
                    dp: {
                        status: "",
                        details: ""
                    },
                    other: {
                        name: "",
                        status: "",
                        details: ""
                    },
                    status: ['Applied', 'Will be Applied', 'Not Applicable']
                },
                cna: {
                    reason: ""
                },
                additionalInfo: "",
                prepared: {
                    by: "",
                    date: new Date().toISOString().split('T')[0]
                },
                checked: {
                    by: "",
                    date: new Date().toISOString().split('T')[0]
                },
                cnm: {
                    cnm: { others: "" },
                    pean: { others: "" },
                    chm: { others: "" },
                },
                rtp: {
                    other: ""
                }
            },
        }
    },
    computed: {
        isReadonly() {
            return this.$store.getters.currentProject.readonly;
        },
        checkSupportMaterial() {
            let check = true;
            this.project.equipments.filter(e => this.isCustomQCM(e) ||
                this.isCustomEquipment(e) || this.isCustomQPME(e) || this.isCustomMethod(e)
            ).forEach(e => {
                check = check && e.supportMaterials.length > 0;
            })
            return !check;
        },
    },
    methods: {
        getCurrentProject() {
            return this.$store.getters.currentProject;
        },
        close() {
            this.$router.replace({ path: '/' });
        },
        nextPage() {
            this.activeIndex = this.activeIndex + 1;
        },
        prevPage() {
            this.activeIndex = this.activeIndex - 1;
        },
        uploadAttachments(files) {
            let props = this;
            for (var i = 0; i < files.length; i++) {
                let file = files[i];
                let attachment = {
                    filename: file.name,
                    projectId: props.project.id,
                    projectPMEId: null,
                    progress: 0
                }
                this.project.attachments.push(attachment);
                let index = this.project.attachments.indexOf(attachment);
                var formData = new FormData();
                formData.append('file', file);

                props.axios({
                    method: "post",
                    url: `${props.apiEndpoint}file?guid=${props.project.guid}&id=${props.project.id}`,
                    data: formData,
                    onUploadProgress: progressEvent => { props.project.attachments[index].progress = Math.round(progressEvent.loaded * 100 / progressEvent.total); }
                })
                    .then(function (response) {
                        props.project.attachments[index].progress = 100;
                        props.axios
                            .post(`${props.apiEndpoint}file`, file)
                            .then(function (response) {
                                props.project.attachments[index].id = response.data;
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }
        },
        saveReport() {
            if (this.project.readonly) return;

            this.printMode = true;

            let props = this;
            this.saving = "pi pi-spin pi-spinner";
            var div = document.getElementsByClassName("p-virtualscroller-content")[0];
            var scaleBy = 2.5;
            var w = div.clientWidth;
            var h = div.clientHeight;
            var canvasTemp = document.createElement('canvas');
            canvasTemp.width = w * scaleBy;
            canvasTemp.height = h * scaleBy;
            canvasTemp.style.width = w + 'px';
            canvasTemp.style.height = h + 'px';
            var context = canvasTemp.getContext('2d');
            context.scale(scaleBy, scaleBy);
            let report = new JsPDF('', 'pt', 'a4');
            report.html(div, {
                callback: function (doc) {
                    props.blobs.push({
                        name: 'Report',
                        data: doc.output('blob'),
                    });
                    props.saving = "pi pi-angle-right";
                    props.nextPage();
                },
                width: 595.28,
                windowWidth: w
            });
        },
        async saveAppendix() {
            if (this.project.readonly) {
                this.saving = "pi pi-angle-right";
                return;
            }
            let tables = document.querySelectorAll(`[id^="b3"]`);
            for (var i = 0; i < tables.length; i++) {
                if ((tables[i].parentElement.parentElement.clientWidth - 50) < tables[i].clientWidth) {
                    tables[i].style.transform = `scale(${(tables[i].parentElement.parentElement.clientWidth - 50) / tables[i].clientWidth})`;
                    tables[i].parentElement.style.height = document.getElementById("refHeight").clientHeight + 'px';
                }
            }
            tables = document.querySelectorAll(`[id^="c3"]`);
            for (var i = 0; i < tables.length; i++) {
                if ((tables[i].parentElement.parentElement.clientWidth - 50) < tables[i].clientWidth) {
                    tables[i].style.transform = `scale(${(tables[i].parentElement.parentElement.clientWidth - 50) / tables[i].clientWidth})`;
                    tables[i].parentElement.style.height = document.getElementById("refHeight").clientHeight + 'px';
                }
            }
            let props = this;
            let appendixList = ["Appendix_A", "Appendix_B", "Appendix_C"];
            if (this.neighborProjects.length > 0) {
                appendixList.push("Appendix_D");
            }
            for (var i = 0; i < appendixList.length; i++) {
                let appendix = appendixList[i];
                let report = new JsPDF('landscape', 'pt', 'a4');
                await report.html(document.querySelector(`#${appendix}`), {
                    callback: function (doc) {
                        props.blobs.push({
                            name: appendix.replace(/_/g, "%20"),
                            data: doc.output('blob'),
                        });
                    },
                    width: 841.89,
                    windowWidth: document.getElementsByClassName("p-virtualscroller-content")[0].clientWidth
                });
            }
            props.saving = "pi pi-angle-right";
            props.nextPage();
        },
        submit() {
            window.onbeforeunload = function () {
                return "Report is still submitting. Are you sure you want to cancel?";
            }
            let user = this.$store.getters.currentUser;
            let props = this;
            this.submitting = true;
            this.submitLabel = "Submitting";
            let promises = [];
            this.blobs.forEach(blob => {
                props.totalProgress += 1;
                let formData = new FormData();
                formData.append('pdf', blob.data);
                promises.push(props.axios({
                    method: "post",
                    url: `${props.apiEndpoint}report?name=${blob.name}&id=${props.project.id}&guid=${props.project.guid}`,
                    data: formData,
                    onUploadProgress: progressEvent => {
                        props.progress += progressEvent.loaded / progressEvent.total
                    }
                }).then(function (response) {
                })
                    .catch(error => {
                        console.log(error);
                    }))
            })
            Promise.all(promises).then(function () {
                props.axios({
                    method: "post",
                    url: `${props.apiEndpoint}report/submit?id=${props.project.id}&guid=${props.project.guid}&userId=${user.id}&email=${props.email}&role=${props.roleInProject}`
                })
                    .then(function (response) {
                        props.axios
                            .get(`${props.apiEndpoint}project?id=${props.project.id}`)
                            .then(response => {
                                props.submitting = false;
                                props.submitLabel = "Submitted";
                                if (response.data.ismultipolygon === 1) {
                                    MapOL.setIsMultipolygon(true);
                                } else {
                                    MapOL.setIsMultipolygon(false);
                                }
                                MapOL.openProjectGISData(props.project.id);
                                response.data = DateHelper.fixUTCDate(response.data);
                                response.data.equipments.forEach(e => {
                                    e.pme = e.officialId != "" ? `${e.officialId} - ${e.otherName}` : e.otherName;
                                })
                                response.data.equipments = response.data.equipments.filter(e =>
                                    response.data.tasks.filter(t => t.id == e.task && t.group == e.group && t.zone == e.zone).length > 0
                                )
                                response.data.readonly = response.data.submitted;
                                props.project = response.data;
                                props.$store.dispatch('setCurrentProject', { project: response.data });
                                props.$store.commit('setProjectId', { value: response.data.id });
                                MapOL.setProjectObject(response.data);
                                props.activeIndex = 0;
                                props.showSubmit = true;
                                props.totalProgress = 0;
                                props.progress = 0;
                                window.onbeforeunload = function () {
                                }
                            })
                            .catch(error => {
                                console.log(error);
                                props.submitPopupLabel = "Failed to submit. Please refresh and try again.";
                                props.submitting = false;
                                props.showSubmit = true;
                            })
                    })
                    .catch(error => {
                        console.log(error);
                        props.submitPopupLabel = "Failed to submit. Please refresh and try again.";
                        props.submitting = false;
                        props.showSubmit = true;
                    })
            });
        },
        selectNSRPointsToReport() {
            this.pointSelectMode = true;
            MapOL.changeNSRPointColorForSelection();
        },
        doneSelect() {
            this.pointSelectMode = false;
            MapOL.changeNSRPointColorBackAfterSelection();
        },
        clearSelection() {
            MapOL.clearNSRPointColorBackSelection();
        },
        changeSelectionMode() {
            if (this.selectionMode === 1) {
                this.selectionMode = 0;
                MapOL.changeNSRPointSelectionModeToDeselect();
            }
            else {
                this.selectionMode = 1;
                MapOL.changeNSRPointSelectionModeToSelect();
            }
        },
        getZoneName(zoneId) {
            return this.project.zones.filter(z => z.id == zoneId)[0].name;
        },
        getConstructionActivity(taskId) {
            return this.project.tasks.filter(t => t.id == taskId)[0].group;
        },
        getTaskName(taskId) {
            return this.project.tasks.filter(t => t.id == taskId)[0].name;
        },
        cleanCalcDetails(calcDetails) {
            let cleaned1 = {};
            calcDetails.forEach(calcDetail => {
                if (cleaned1[calcDetail.taskid]) {
                    if (cleaned1[calcDetail.taskid].exclusivegroups[calcDetail.exclusivegroup]) {
                        cleaned1[calcDetail.taskid].exclusivegroups[calcDetail.exclusivegroup].pmes.push(calcDetail)
                    }
                    else {
                        cleaned1[calcDetail.taskid].exclusivegroups[calcDetail.exclusivegroup] = {
                            groupswl: calcDetail.groupswl,
                            pmes: [calcDetail]
                        }
                    }
                }
                else {
                    let cleanedDetail = {
                        zoneid: calcDetail.zoneid,
                        taskid: calcDetail.taskid,
                        exclusivegroups: {},
                        highestswl: calcDetail.highestswl
                    }
                    cleanedDetail.exclusivegroups[calcDetail.exclusivegroup] = {
                        groupswl: calcDetail.groupswl,
                        pmes: [calcDetail]
                    }
                    cleaned1[calcDetail.taskid] = cleanedDetail;
                }
            })
            let cleaned2 = [];
            Object.keys(cleaned1).forEach(taskid => {
                let c = cleaned1[taskid];
                let constructionActivity = this.getConstructionActivity(taskid) == "-" ? this.getTaskName(taskid) : `${this.getConstructionActivity(taskid)} - ${this.getTaskName(taskid)}`;
                let filtered = cleaned2.filter(c2 => c2.constructionActivity == constructionActivity);
                let exists = false;
                if (filtered.length > 0) {
                    if (Math.round(filtered[0].highestswl) == Math.round(c.highestswl)) {
                        Object.keys(c.exclusivegroups).forEach(ex => {
                            if (!filtered[0].exclusivegroups[ex]) {
                                return;
                            }
                            if (Math.round(filtered[0].exclusivegroups[ex].groupswl) == Math.round(c.exclusivegroups[ex].groupswl) && filtered[0].exclusivegroups[ex].pmes.length == c.exclusivegroups[ex].pmes.length) {
                                c.exclusivegroups[ex].pmes.forEach(pme => {
                                    let filtered2 = filtered[0].exclusivegroups[ex].pmes.filter(pme2 =>
                                        pme.pmename == pme2.pmename
                                        && pme.pmeref == pme2.pmeref
                                        && pme.swl == pme2.swl
                                        && pme.qty == pme2.qty
                                        && pme.timepercent == pme2.timepercent
                                        && pme.mitigationmeasure == pme2.mitigationmeasure
                                        && pme.mitigationeffect == pme2.mitigationeffect
                                        && Math.round(pme.mitigatedswl) == Math.round(pme2.mitigatedswl)
                                    );
                                    if (filtered2.length == 0) return;
                                });
                            }
                        })
                    }
                }
                if (!exists) {
                    cleaned2.push({
                        constructionActivity: constructionActivity,
                        ...c
                    });
                }
            })
            let final = [];
            cleaned2.forEach(c2 => {
                Object.keys(c2.exclusivegroups).forEach(ex => {
                    final.push(...c2.exclusivegroups[ex].pmes);
                })
            })
            return final.sort((a, b) => {
                let constructionActivityA = this.getConstructionActivity(a.taskid) == "-" ? this.getTaskName(a.taskid) : `${this.getConstructionActivity(a.taskid)} - ${this.getTaskName(a.taskid)}`;
                let constructionActivityB = this.getConstructionActivity(b.taskid) == "-" ? this.getTaskName(b.taskid) : `${this.getConstructionActivity(b.taskid)} - ${this.getTaskName(b.taskid)}`;
                return (constructionActivityA > constructionActivityB) ? 1 : -1
            });
        },
        togglePrintMode() {
            this.printMode = !this.printMode;
            const inputs = document.querySelectorAll('input');
            for (const input of inputs) {
                // we only need to check for radio if assessment-status-radio is merged
                if (input.type === 'checkbox' || input.type === 'radio') {
                    input.disabled = !input.disabled
                }
            }
        },
        isCustomQCM(e) {
            return e.customQCMName && e.customQCMName != "";
        },
        isCustomEquipment(e) {
            return e.defaultNoisePower != e.noisePower && !e.pme.startsWith('CNP');
        },
        isCustomQPME(e) {
            return e.qpmeDefaultNoisePower != e.qpmeNoisePower && e.qpmeDefaultNoisePower && e.qpmeNoisePower != 0;
        },
        isCustomMethod(e) {
            return e.custommethodname != "" && e.custommethoddba != 0;
        }
    },
    beforeMount() {
        if (this.project.readonly) return;
        this.project.groups = [];
        this.project.siteImage = [];
        this.project.calcResultDetailsUnmitigated = [];
        this.project.calcResultDetailsMitigated = [];
        this.project.calcResultNSRUnmitigated = [];
        this.project.calcResultNSRMitigated = [];
        let props = this;
        MapOL.zoomToCurrentBuffer(this.project.id);
        if (!props.project.guid) {
            console.log("missing guid")
            props.axios
                .get(`${props.apiEndpoint}project?id=${props.project.id}`)
                .then(response => {
                    props.project.guid = response.data.guid;
                    console.log(props.project.guid);
                })
        }
    },
    mounted() {
        this.project.equipments.filter(e => this.isCustomQCM(e) || this.isCustomEquipment(e) || this.isCustomQPME(e) || this.isCustomMethod(e)).forEach(e => {
            if (this.userDefinedEquipments.filter(u => (u.pme == e.pme && u.noisePower == e.noisePower)
                && (u.qpmename == e.qpmename && u.qpmeNoisePower == e.qpmeNoisePower)
                && (u.custommethodname == e.custommethodname && u.custommethoddba == e.custommethoddba)).length == 0) {
                this.userDefinedEquipments.push(e);
            }
        })
        if (this.project.readonly) {
            this.loading = false;
            return;
        }

        //wait for canvas updates
        setTimeout(() => {
            MapOL.getMapCanvas().forEach(image => {
                this.project.siteImage.push(image.toDataURL("image/png"));
            });
        }, 1000);
        let props = this;
        let calcResult = [];
        this.project.zones.sort((a, b) => (
            a.name.localeCompare(
                b.name, undefined, {
                numeric: true,
                sensitivity: 'base'
            })));
        this.project.tasks.forEach(t => {
            let filtered = this.project.groups.filter(g => g.name == t.group && g.zone == t.zone);
            if (filtered.length == 0) {
                this.project.groups.push({
                    zone: t.zone,
                    name: t.group,
                    start: t.start,
                    end: t.end
                })
            }
            else {
                filtered[0].start = filtered[0].start < t.start ? filtered[0].start : t.start;
                filtered[0].end = filtered[0].end > t.end ? filtered[0].end : t.end;
            }
        });
        this.project.groups.sort((a, b) => (
            this.project.zones.filter(z => z.id == a.zone)[0].name.localeCompare(
                this.project.zones.filter(z => z.id == b.zone)[0].name, undefined, {
                numeric: true,
                sensitivity: 'base'
            })));
        this.project.tasks.sort((a, b) => (this.project.zones.filter(z => z.id == a.zone)[0].name + a.group + a.start).localeCompare(
            this.project.zones.filter(z => z.id == b.zone)[0].name + b.group + b.start, undefined, {
            numeric: true,
            sensitivity: 'base'
        }));
        MapOL.calculatedNoiseGroupArray().forEach(calc => {
            let building = calcResult.filter(c => c.buildingId == calc.buildingid)
            if (building.length > 0) {
                building[0].maxCNL = building[0].maxCNL < calc.totalcnl ? calc.totalcnl : building[0].maxCNL,
                    building[0].startDate = building[0].startDate > calc.startDate ? calc.startDate : building[0].startDate,
                    building[0].endDate = building[0].endDate < calc.endDate ? calc.endDate : building[0].endDate,
                    building[0].results.push({
                        startDate: calc.startDate,
                        endDate: calc.endDate,
                        totalCNL: calc.totalcnl
                    })
                building[0].results.sort((a, b) => (a.startDate > b.startDate) ? 1 : -1);
            }
            else {
                calcResult.push({
                    buildingId: calc.buildingid,
                    buildingName: calc.buildingName,
                    noiseCriteria: calc.noiseCriteria,
                    maxCNL: calc.totalcnl,
                    startDate: calc.startDate,
                    endDate: calc.endDate,
                    results: [{
                        startDate: calc.startDate,
                        endDate: calc.endDate,
                        totalCNL: calc.totalcnl
                    }]
                })
            }
        })
        calcResult.sort((a, b) => (a.maxCNL > a.noiseCriteria) || (a.buildingId < b.buildingId) ? -1 : 1);
        this.project.calcResult = calcResult;
        let selectedNSRPointIds = MapOL.getSelectedNSRPointIds().map(id => id.toString());
        let taskIds = props.project.tasks.map(t => t.id);
        let promises = [];
        promises.push(props.axios
            .get(`${props.apiEndpoint}calculationresultdetail?projectid=${props.project.id}`)
            .then(response => {
                response.data.sort((a, b) => (a.taskid + a.exclusivegroup > b.taskid + b.exclusivegroup) ? 1 : -1);
                props.project.calcResultDetailsUnmitigated = response.data.filter(c => !c.ismitigated && taskIds.includes(c.taskid.toString()));
                props.project.calcResultDetailsMitigated = response.data.filter(c => c.ismitigated && taskIds.includes(c.taskid.toString()));
            })
        );
        promises.push(props.axios
            .get(`${props.apiEndpoint}calculationresultnsr?projectid=${props.project.id}`)
            .then(response => {
                response.data.sort((a, b) => (a.buildingName + a.taskid + a.exclusivegroup > b.buildingName + b.taskid + b.exclusivegroup) ? 1 : -1);
                props.project.calcResultNSRUnmitigated = response.data.filter(c => !c.ismitigated && (selectedNSRPointIds.includes(c.nsrpointid.toString()) || selectedNSRPointIds.includes(c.nsrpointid)));
                props.project.calcResultNSRMitigated = response.data.filter(c => c.ismitigated && (selectedNSRPointIds.includes(c.nsrpointid.toString() || selectedNSRPointIds.includes(c.nsrpointid))));
                console.log("calcResultNSRMitigated", props.project.calcResultNSRMitigated)
            })
        )
        promises.push(props.axios
            .get(`${props.apiEndpoint}projectnsrpointhistory?projectid=${props.project.id}`)
            .then(response => {
                response.data.sort((a, b) => a.id_0 - b.id_0);
                props.project.nsrPointHistory = response.data;
                console.log("projectnsrpointhistory", response.data)
            })
        )
        MapOL.getApprovedProjectIds().forEach(id => {
            promises.push(props.axios
                .get(`${this.apiEndpoint}project?id=${id}`)
                .then(response => {
                    response.data = DateHelper.fixUTCDate(response.data);
                    response.data.equipments.forEach(e => {
                        e.pme = e.officialId != "" ? `${e.officialId} - ${e.otherName}` : e.otherName;
                    })
                    response.data.equipments = response.data.equipments.filter(e =>
                        response.data.tasks.filter(t => t.id == e.task && t.group == e.group && t.zone == e.zone).length > 0
                    )
                    response.data.groups = [];
                    response.data.tasks.forEach(t => {
                        let filtered = response.data.groups.filter(g => g.name == t.group && g.zone == t.zone);
                        if (filtered.length == 0) {
                            response.data.groups.push({
                                zone: t.zone,
                                name: t.group,
                                start: t.start,
                                end: t.end
                            })
                        }
                        else {
                            filtered[0].start = filtered[0].start < t.start ? filtered[0].start : t.start;
                            filtered[0].end = filtered[0].end > t.end ? filtered[0].end : t.end;
                        }
                    });
                    response.data.groups.sort((a, b) => (
                        response.data.zones.filter(z => z.id == a.zone)[0].name.localeCompare(
                            response.data.zones.filter(z => z.id == b.zone)[0].name, undefined, {
                            numeric: true,
                            sensitivity: 'base'
                        })));
                    props.neighborProjects.push(response.data);
                })
            );
        })
        Promise.all(promises).then(function () {
            props.project.calcResultDetailsUnmitigatedCleaned = props.cleanCalcDetails(props.project.calcResultDetailsUnmitigated).filter(c => taskIds.includes(c.taskid.toString()));
            props.project.calcResultDetailsMitigatedCleaned = props.cleanCalcDetails(props.project.calcResultDetailsMitigated).filter(c => taskIds.includes(c.taskid.toString()));
            props.project.nsrPointHistory.forEach(h => {
                props.project.calcResultNSRMitigated.filter(c => c.nsrpointid === h.id).forEach(c => {
                    console.log("history", h)
                    c = { ...c, ...h }
                    console.log("history", c)
                })
            })
            console.log("calcResultNSRMitigated", props.project.calcResultNSRMitigated)
            props.loading = false;
        });
    }
}
</script>
<style lang="less">
.appendixContent {
    font-family: 'Times New Roman', Times, serif;
    text-align: left;
    color: black;
}
</style>
<style scoped>
.report {
    width: 794px;
    position: absolute;
    left: calc(50vw - (794px / 2));
    transform: translate(0%, 2%);
}

.appendix {
    width: 1129px;
    position: absolute;
    left: calc(50vw - (1129px / 2));
    transform: translate(0%, 5%);
}

.minimizeRight {
    /* width: 40vw;
    position: absolute;
    transform: translate(70%, 0%);
    top: 70vh;
    height: 21vh;
    overflow: hidden; */
    width: 20vw;
    position: absolute;
    transform: translate(390%, 0%);
    top: 15vh;
    height: 70vh;
    overflow: hidden;
}

.center {
    width: 20vw;
    position: absolute;
    transform: translate(-50%, 0);
    top: 40vh;
    left: 50vw;
}
</style>